// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"a4935ea3","453":"63b0cb4a","455":"f99cf131","977":"fadd3299"}[chunkId] + ".chunk.js";
};